import { apiV2 } from 'src/services/storage/settings/http'
import * as types from './types'

export * from './types'

export const getSettings = (params: types.IGetSettingsParams) =>
  apiV2.get<types.IGetSettingsData>(`/settings`, { params })

export const patchSettings = (data: types.IPatchSettingsParams) =>
  apiV2.patch<types.IPatchSettingsData>(`/settings`, data)
